module.exports = __webpack_public_path__ + "HelveticaBold.ttf";